document.addEventListener('DOMContentLoaded', (e) => {
    let mblButton = document.querySelector('.menu-mobile-button');
    let menu = document.querySelector('#main_menu');
    mblButton.addEventListener('click', (e) => {
        e.preventDefault();
        if ( !mblButton.classList.contains('active') ) {
            mblButton.classList.add('active');
            menu.classList.add('active');
        } else {
            mblButton.classList.remove('active');
            menu.classList.remove('active');
        }
    })
});